import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Qc8110SearchParamsSchema = z
  .object({
    lotNo: z.string().optional(),
    type: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    itemId: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Qc8110SearchParams = z.infer<typeof Qc8110SearchParamsSchema>

export const Qc8110SearchResultModelSchema = z.object({
  id: z.string(),
  date: z.coerce.date(),
  lotNo: z.string(),
  qty: z.number(),
  type: z.number(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  itemId: z.number(),
})

export type Qc8110SearchResultModel = z.infer<
  typeof Qc8110SearchResultModelSchema
>

export const Qc8110SearchResultSchema = z
  .object({
    data: z.array(Qc8110SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Qc8110SearchResult = z.infer<typeof Qc8110SearchResultSchema>
